import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';

const Webhooks = lazyWithRetry(() => import('./Webhooks'));

const WebhooksRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="webhooks-settings">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Webhooks />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default WebhooksRoutes;
